export default __webpack_public_path__ + "static/media/dropdown.6d77231e.svg";